<template>
  <div class="add-intent-modal">
    <n-modal @cancel="close()">
      <template #title>
        <p class="modal-card-title">Add a new intent</p>
      </template>

      <template #body>
        <div class="edit-title-container">
          <label for="intent-name-input" class="label">Name</label>
          <div class="field">
            <input
              ref="intentNameInput"
              v-model="intentTitle"
              label="Intent name"
              class="input"
              type="text"
              placeholder="Enter Intent Name"
              @input="$v.intentTitle.$touch()"
              @keyup.enter="createIntent"
            />
            <p class="help is-danger" v-if="errorMessage">
              {{ errorMessage }}
            </p>
          </div>
        </div>
      </template>

      <template v-slot:buttons>
        <n-button-group>
          <n-button variant="primary" @click="createIntent" :disabled="$v.$invalid">Add</n-button>
          <n-button @click="close" variant="primary--outline">Cancel</n-button>
        </n-button-group>
      </template>
    </n-modal>
  </div>
</template>

<script lang="ts" setup>
import { required, maxLength } from '@vuelidate/validators';
import { computed, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';

const emit = defineEmits<{
  (e: 'create', intent: string): void;
  (e: 'close'): void;
}>();

const intentTitle = ref('');
const intentNameInput = ref<HTMLInputElement | null>(null);

const validations = {
  intentTitle: {
    required,
    validIntentName: (value: string) => value.search(/[<>*%&:\\$]/) === -1,
    maxLength: maxLength(50),
  },
};

const $v = useVuelidate(validations, { intentTitle });
const isTitleRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, 'intentTitle'));

function close() {
  $v.value.$reset();
  intentTitle.value = '';
  emit('close');
}

function createIntent() {
  if ($v.value.$invalid) {
    return;
  }
  emit('create', intentTitle.value);
  close();
}

const errorMessage = computed(() => {
  if ($v.value.intentTitle.required.$invalid) {
    return 'Name must not be empty';
  } else if ($v.value.intentTitle.validIntentName.$invalid) {
    return 'Name must not contain <, >, *, %, &, :, \\, $';
  } else if ($v.value.intentTitle.maxLength.$invalid) {
    return 'Name must not be longer than 50 characters';
  }

  return '';
});
</script>
